module.exports = __webpack_public_path__ + "img/AGR-A-1-II.7419c862.png";